import { render, staticRenderFns } from "./starand.vue?vue&type=template&id=835b08b8&scoped=true"
import script from "./starand.vue?vue&type=script&lang=js"
export * from "./starand.vue?vue&type=script&lang=js"
import style0 from "./starand.vue?vue&type=style&index=0&id=835b08b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835b08b8",
  null
  
)

export default component.exports